import React, {useContext, useState} from "react"
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Select, {SelectOption} from "@amzn/meridian/select";
import Text from "@amzn/meridian/text";
import {StageFilterContext} from "./context/StageFilterContext";
import Tag from "@amzn/meridian/tag";
import {FormattedMessage} from "react-intl";
import ExportCSV from "../exportcsv/ExportCSV";
import {getStageDataInCSVFormat} from "../util/ExportUtils";
import {RouteStageContext} from "./context/RouteStageContext";
import {CapabilityContext} from "../global/context/CapabilityContext";

const StageFilter = () => {
    const {viewModelF, dispatchF} = useContext(StageFilterContext)
    const {configViewModel} = useContext(CapabilityContext)
    const [filterState, setFilterState] = useState(false);
    const {viewModel} = useContext(RouteStageContext)

    const toggleFilter = () => {
        setFilterState(!filterState);
    };

    const stageDataConversionHandler = () => {
        return getStageDataInCSVFormat(viewModel.cartList,
            viewModel.routeList,
            viewModelF.viewType,
            configViewModel.capability,
            configViewModel.stationConfig);
    }

    const isFilterSet = () => {
        let result = false;
        Object.entries(viewModelF).forEach(entry => {
            const key = entry[0];
            const values = entry[1];
            result = result || (Array.isArray(values) && values.length && key !== 'data');
        });
        return result;
    }

    const clearAllFilters = () => {
        dispatchF({type: 'REMOVE_ALL_FILTER'});
    }

    return (
        <Column>
            <Row width="100%" spacingInset="medium large none large">
                <Link href="" type="secondary" onClick={toggleFilter}>Options</Link>
                <Row spacing={"small"}>
                    {Object.entries(viewModelF).map(entry => {
                        const key = entry[0]
                        const values = entry[1]
                        return (
                            (Array.isArray(values) && key !== 'data') ? values.map(value => {
                                return <Tag key={value} type="neutral"
                                            onClose={() => dispatchF({
                                                type: 'REMOVE_FILTER',
                                                data: {key, value}
                                            })}>{value}</Tag>
                            }) : null
                        )
                    })}
                    {isFilterSet() ? <Link onClick={clearAllFilters} type="secondary">Clear all</Link> : null}
                </Row>
            </Row>
            {filterState ?
                <Row width="100%" spacing="none" spacingInset="medium large medium large" backgroundColor="secondary">
                    <Column heights="fill" alignmentHorizontal="left" spacingInset="none small none">
                        <Text type="h100" alignment="left">
                            <FormattedMessage id="stageFilter.departure" defaultMessage="Departure"/>
                        </Text>
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_DEPARTURE', Departure: data})}
                            value={viewModelF.departure}
                            size="small"
                            placeholder="Departure"
                            width={150}>
                            {[...viewModelF.data.departure].sort().map(departure => (
                                <SelectOption key={departure} label={"Departing " + departure}
                                              value={departure}/>
                            ))}
                        </Select>
                    </Column>
                    <Column heights="fill" alignmentHorizontal="left" spacingInset="none small none">
                        <Text type="h100" alignment="left">
                            <FormattedMessage id="stageFilter.driverType" defaultMessage="Driver Type"/>
                        </Text>
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_DRIVER_TYPE', DriverType: data})}
                            value={viewModelF.driverType}
                            size="small"
                            placeholder="Driver Type"
                            width={150}>
                            {[...viewModelF.data.driverType].sort().map(driverType => (
                                <SelectOption key={driverType} label={driverType} value={driverType}/>
                            ))}
                        </Select>
                    </Column>
                    <Column heights="fill" alignmentHorizontal="left" spacingInset="none small none">
                        <Text type="h100" alignment="left">
                            <FormattedMessage id="stageFilter.cluster" defaultMessage="Cluster"/>
                        </Text>
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_CLUSTER', Cluster: data})}
                            value={viewModelF.cluster}
                            size="small"
                            placeholder="Cluster"
                            width={150}>
                            {[...viewModelF.data.cluster].sort().map(cluster => (
                                <SelectOption key={cluster} label={cluster} value={cluster}/>
                            ))}
                        </Select>
                    </Column>
                    <Column heights="fit" alignmentHorizontal="left" spacingInset="none small none">
                        <Text type="h100" alignment="left">
                            &nbsp;
                        </Text>
                        <ExportCSV csvDataProvider={stageDataConversionHandler} filePrefix={"STAGE"}/>
                    </Column>
                </Row>
                : null}
        </Column>
    )
}

export default StageFilter



// WEBPACK FOOTER //
// ./src/components/stageStatus/StageFilter.js